import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { UsageRecord, UsageRecordCreate, UsageRecordFilter } from '../data/usageRecord';

export function createUsageRecordService(client: AxiosInstance) {
  return createCrudService<UsageRecord, UsageRecordCreate, UsageRecordFilter>(
    client,
    '/accounting/UsageRecord',
    'id',
  );
}

export type UsageRecordService = CrudService<UsageRecord, UsageRecordCreate, UsageRecordFilter>;
